module.exports = __webpack_public_path__ + "static/media/trx.c1b0179d.svg";